import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/10 backdrop-blur-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/b286a2ed3ca10247dabf9d64ba360efd/4a2f680fd9270aa1e53542f2d7d9bd09.png" 
              alt="CDE MIPYME Valle de Sula"
              className="h-14 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className={`font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0066CC]' : 'text-white hover:text-white/80'
              }`}
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('quienes-somos')}
              className={`font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0066CC]' : 'text-white hover:text-white/80'
              }`}
            >
              Quiénes Somos
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className={`font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0066CC]' : 'text-white hover:text-white/80'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('programas')}
              className={`font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0066CC]' : 'text-white hover:text-white/80'
              }`}
            >
              Programas
            </button>
            <button
              onClick={() => scrollToSection('noticias')}
              className={`font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0066CC]' : 'text-white hover:text-white/80'
              }`}
            >
              Noticias
            </button>
            <button
              onClick={() => scrollToSection('galeria')}
              className={`font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0066CC]' : 'text-white hover:text-white/80'
              }`}
            >
              Galería
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className={`font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0066CC]' : 'text-white hover:text-white/80'
              }`}
            >
              Contacto
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contacto')}
            className="bg-[#0066CC] text-white px-6 py-2.5 rounded-lg font-medium hover:bg-[#0052A3] transition-all duration-300 flex items-center space-x-2 whitespace-nowrap"
          >
            <span>Solicita Asesoría</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
